// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_POSTS_SHOW_MORE = "V\u00edce diskuz\u00ed...";
